import storage from './localstorage.jsx'

function _setSidebarExpand (bExpand) {
  if (storage) storage.setItem('sidebarExpand', bExpand)
}

function _getSidebarExpand () {
  let bExpand = false
  if (storage) {
    if (storage.getItem('sidebarExpand') === 'false') {
      bExpand = false
    } else if (storage.getItem('sidebarExpand') === 'true') {
      bExpand = true
    }
  }

  return bExpand
}

const SidebarUtil = {}
SidebarUtil.setSidebarExpand = _setSidebarExpand
SidebarUtil.getSidebarExpand = _getSidebarExpand

export default SidebarUtil
